import React, { useCallback, useState } from 'react'
import Button from '@mui/material/Button'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import { styled } from '@mui/material/styles'

const ButtonStyled = styled(Button)({
  marginLeft: 'auto',
})

export default function Geocoder(props) {
  const [location, setLocation] = useState([])

  const clear = () => {
    setLocation([])
  }

  const save = () => {
    if (location.length) {
      props.setCenter(location)
    }
  }

  const handleOk = () => {
    save()
    clear()
  }

  const geocoderEl = useCallback(node => {
    if (node !== null) {
      var geocoder = new MapboxGeocoder({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        countries: 'au',
      })

      geocoder.addTo(node)
      geocoder.on('results', function (e) {
        //console.log('results', e)
      })
      geocoder.on('result', function (e) {
        //console.log('result', e)
        setLocation([
          e.result.geometry.coordinates[0],
          e.result.geometry.coordinates[1],
        ])
      })
    }
  }, [])

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: '1' }} ref={geocoderEl} />
      <ButtonStyled onClick={handleOk} color="primary">
        Ok
      </ButtonStyled>
    </div>
  )
}
